

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    list: []
}

const progressReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_DATAROOMS_LIST:
            return {
                ...state,
                list: action?.list,
            }
        case actionTypes.SET_ROUNDS_LIST:
            return {
                ...state,
                rounds_list: action?.rounds_list,
            }
        default:
            return state;
    }
}

export default progressReducer
